import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
import VueRouter from 'vue-router'
import router from '@/router'
import axios from 'axios'
import store from '@/store'
import * as echarts from 'echarts'

Vue.use(ElementUI).use(VueRouter)
Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js